import script from "./PrismEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./PrismEditor.vue?vue&type=script&lang=ts&setup=true"

import "./PrismEditor.vue?vue&type=style&index=0&id=bd4e2818&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd4e2818"]])

export default __exports__